import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './AuthPage.css';
import { clearAuthSession } from './authSession';
import { API_BASE } from './config/api';

const REMEMBER_EMAIL_KEY = 'authRememberEmail';

const HERO_DESCRIPTION =
  'Платформа для медиапланирования наружной рекламы: подбирайте поверхности, считайте охват и частоту, сравнивайте сценарии и управляйте кампаниями в одном интерфейсе.';

function BrandMark({ fill = '#3B5EE9' }) {
  return (
    <svg width="24" height="21" viewBox="0 0 24 21" fill="none" aria-hidden>
      <path
        d="M12.8252 0.00553429C13.5238 0.00466141 14.2681 -0.00864774 14.9629 0.00944054L16.3281 1.35612C17.1603 1.40348 18.2089 1.37365 19.0596 1.3737L23.9785 1.37565L23.9766 4.94206C23.9778 5.8302 24.1586 6.97551 23.4893 7.63444C23.2976 7.82423 23.0604 7.96164 22.8008 8.03385C22.3898 8.14532 20.5827 8.09134 20.0332 8.10026L20.042 13.6149C19.0755 14.4848 17.9843 15.3355 17.0127 16.2087C16.6798 16.5079 16.0904 16.9461 15.8027 17.235C15.7804 18.1798 15.7912 19.1929 15.7988 20.1413C14.4341 20.1442 13.0334 20.1256 11.6738 20.1462C11.6744 19.2108 11.6564 18.2089 11.6807 17.279L5.28516 17.277C5.06517 18.1646 4.80853 19.2789 4.5459 20.1423H0C0.234441 19.011 0.43135 17.7061 0.616211 16.5612L1.29395 12.4294L1.77734 9.49772C1.84715 9.0903 1.99566 8.38845 2.03711 8.01042C2.15221 7.94336 2.88744 7.9723 3.08008 7.97233H5.0957C6.79086 7.97211 8.61717 7.93918 10.3027 7.98014C10.8741 7.36907 11.4878 6.7869 12.0742 6.1901C12.2984 5.96199 12.6176 5.67045 12.8242 5.43717C12.83 3.64114 12.8449 1.80052 12.8252 0.00553429ZM19.9941 14.4958C20.0663 14.5668 20.041 15.7394 20.041 15.9118L20.043 18.8512C20.0417 19.1121 20.0171 19.9191 20.0537 20.1432H16.8789C16.7575 20.1477 16.6823 20.1563 16.5645 20.1198C16.4902 19.8305 16.5485 17.868 16.5488 17.4479C16.997 17.0301 17.5495 16.5891 18.0234 16.1911C18.6872 15.634 19.3441 15.0688 19.9941 14.4958ZM8.87988 17.9049C8.85453 18.6081 8.87522 19.4291 8.87793 20.1413L8.28516 20.1432L5.22754 20.1393C5.4198 19.5931 5.66498 18.5256 5.83789 17.9079L8.87988 17.9049ZM18.2441 3.12663C17.6785 3.12759 17.0846 3.13804 16.5215 3.12858L16.5195 4.27702L18.2432 4.27311L18.2441 3.12663Z"
        fill={fill}
      />
    </svg>
  );
}

function HeroMark() {
  return (
    <svg className="kb-auth-hero-mark" viewBox="0 0 24 21" fill="none" aria-hidden>
      <path
        d="M12.8252 0.00553429C13.5238 0.00466141 14.2681 -0.00864774 14.9629 0.00944054L16.3281 1.35612C17.1603 1.40348 18.2089 1.37365 19.0596 1.3737L23.9785 1.37565L23.9766 4.94206C23.9778 5.8302 24.1586 6.97551 23.4893 7.63444C23.2976 7.82423 23.0604 7.96164 22.8008 8.03385C22.3898 8.14532 20.5827 8.09134 20.0332 8.10026L20.042 13.6149C19.0755 14.4848 17.9843 15.3355 17.0127 16.2087C16.6798 16.5079 16.0904 16.9461 15.8027 17.235C15.7804 18.1798 15.7912 19.1929 15.7988 20.1413C14.4341 20.1442 13.0334 20.1256 11.6738 20.1462C11.6744 19.2108 11.6564 18.2089 11.6807 17.279L5.28516 17.277C5.06517 18.1646 4.80853 19.2789 4.5459 20.1423H0C0.234441 19.011 0.43135 17.7061 0.616211 16.5612L1.29395 12.4294L1.77734 9.49772C1.84715 9.0903 1.99566 8.38845 2.03711 8.01042C2.15221 7.94336 2.88744 7.9723 3.08008 7.97233H5.0957C6.79086 7.97211 8.61717 7.93918 10.3027 7.98014C10.8741 7.36907 11.4878 6.7869 12.0742 6.1901C12.2984 5.96199 12.6176 5.67045 12.8242 5.43717C12.83 3.64114 12.8449 1.80052 12.8252 0.00553429ZM19.9941 14.4958C20.0663 14.5668 20.041 15.7394 20.041 15.9118L20.043 18.8512C20.0417 19.1121 20.0171 19.9191 20.0537 20.1432H16.8789C16.7575 20.1477 16.6823 20.1563 16.5645 20.1198C16.4902 19.8305 16.5485 17.868 16.5488 17.4479C16.997 17.0301 17.5495 16.5891 18.0234 16.1911C18.6872 15.634 19.3441 15.0688 19.9941 14.4958ZM8.87988 17.9049C8.85453 18.6081 8.87522 19.4291 8.87793 20.1413L8.28516 20.1432L5.22754 20.1393C5.4198 19.5931 5.66498 18.5256 5.83789 17.9079L8.87988 17.9049ZM18.2441 3.12663C17.6785 3.12759 17.0846 3.13804 16.5215 3.12858L16.5195 4.27702L18.2432 4.27311L18.2441 3.12663Z"
        fill="currentColor"
      />
    </svg>
  );
}

function EyeIcon({ crossed = false }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path
        d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8s-2.5 4.5-6.5 4.5S1.5 8 1.5 8Z"
        stroke="#191921"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="8" cy="8" r="2" stroke="#191921" strokeWidth="1.5" />
      {crossed && (
        <path
          d="M3 13.5 13 2.5"
          stroke="#191921"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      )}
    </svg>
  );
}

function apiErrorMessage(data, fallback) {
  if (Array.isArray(data?.message)) return data.message.join(', ');
  return data?.message || fallback;
}

export default function AuthPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const resetTokenFromUrl = searchParams.get('resetToken') || '';

  const [mode, setMode] = useState(() => (resetTokenFromUrl ? 'reset' : 'login'));
  const [email, setEmail] = useState(() => localStorage.getItem(REMEMBER_EMAIL_KEY) || '');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [remember, setRemember] = useState(() => Boolean(localStorage.getItem(REMEMBER_EMAIL_KEY)));
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetToken, setResetToken] = useState(resetTokenFromUrl);

  const redirectTo = useMemo(() => {
    const redirectParam = searchParams.get('redirect');
    if (!redirectParam || !redirectParam.startsWith('/')) {
      return '/campaigns';
    }
    return redirectParam;
  }, [searchParams]);

  const sessionExpired = searchParams.get('reason') === 'session_expired';

  useEffect(() => {
    if (resetTokenFromUrl) {
      setResetToken(resetTokenFromUrl);
      setMode('reset');
      setError('');
      setInfo('Придумайте новый пароль для входа.');
    }
  }, [resetTokenFromUrl]);

  useEffect(() => {
    if (resetTokenFromUrl) return undefined;
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate(redirectTo, { replace: true });
    }
    return undefined;
  }, [navigate, redirectTo, resetTokenFromUrl]);

  useEffect(() => {
    if (sessionExpired) {
      clearAuthSession();
      setError('Сессия истекла. Войдите снова.');
    }
  }, [sessionExpired]);

  const switchMode = (nextMode) => {
    setMode(nextMode);
    setError('');
    setInfo('');
    setPassword('');
    setConfirmPassword('');
    setShowPassword(false);
    if (nextMode !== 'reset') {
      setResetToken('');
      if (searchParams.has('resetToken')) {
        navigate('/auth', { replace: true });
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setInfo('');

    const normalizedEmail = email.trim().toLowerCase();

    if (mode === 'forgot') {
      if (!normalizedEmail) {
        setError('Введите email');
        return;
      }
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE}/auth/forgot-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: normalizedEmail }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          setError(apiErrorMessage(data, 'Не удалось отправить письмо'));
          return;
        }
        setInfo(data.message || 'Если аккаунт существует, мы отправили ссылку на email.');
      } catch {
        setError('Сервер недоступен. Проверьте back_traffic_roads');
      } finally {
        setLoading(false);
      }
      return;
    }

    if (mode === 'reset') {
      if (!resetToken) {
        setError('Ссылка для сброса недействительна. Запросите новую.');
        return;
      }
      if (!password || password.length < 6) {
        setError('Пароль должен быть не короче 6 символов');
        return;
      }
      if (password !== confirmPassword) {
        setError('Пароли не совпадают');
        return;
      }
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE}/auth/reset-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token: resetToken, password }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          setError(apiErrorMessage(data, 'Не удалось сбросить пароль'));
          return;
        }
        setPassword('');
        setConfirmPassword('');
        setResetToken('');
        setMode('login');
        setInfo(data.message || 'Пароль обновлён. Войдите с новым паролем.');
        navigate('/auth', { replace: true });
      } catch {
        setError('Сервер недоступен. Проверьте back_traffic_roads');
      } finally {
        setLoading(false);
      }
      return;
    }

    if (!normalizedEmail || !password) {
      setError('Введите email и пароль');
      return;
    }

    if (mode === 'register' && password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setLoading(true);
    try {
      const endpoint = mode === 'register' ? '/auth/register' : '/auth/login';
      const response = await fetch(`${API_BASE}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: normalizedEmail, password }),
      });

      const data = await response.json();
      if (!response.ok) {
        setError(apiErrorMessage(data, 'Ошибка авторизации'));
        return;
      }

      if (remember) {
        localStorage.setItem(REMEMBER_EMAIL_KEY, normalizedEmail);
      } else {
        localStorage.removeItem(REMEMBER_EMAIL_KEY);
      }

      localStorage.setItem('authToken', data.token);
      localStorage.setItem('authEmail', data.user?.email || normalizedEmail);
      navigate(redirectTo, { replace: true });
    } catch {
      setError('Сервер недоступен. Проверьте back_traffic_roads');
    } finally {
      setLoading(false);
    }
  };

  const isLogin = mode === 'login';
  const isRegister = mode === 'register';
  const isForgot = mode === 'forgot';
  const isReset = mode === 'reset';

  const title = isForgot
    ? 'Восстановление пароля'
    : isReset
      ? 'Новый пароль'
      : isLogin
        ? 'Вход'
        : 'Регистрация';

  const submitLabel = loading
    ? 'Подождите...'
    : isForgot
      ? 'Отправить ссылку'
      : isReset
        ? 'Сохранить пароль'
        : isLogin
          ? 'Войти'
          : 'Создать аккаунт';

  const panelLabel = isForgot
    ? 'Восстановление пароля'
    : isReset
      ? 'Новый пароль'
      : isLogin
        ? 'Вход'
        : 'Регистрация';

  return (
    <div className="kb-auth">
      <section className="kb-auth-hero" aria-label="О продукте">
        <HeroMark />
        <div className="kb-auth-hero-copy">
          <h2 className="kb-auth-hero-brand">Купи.баннер</h2>
          <p className="kb-auth-hero-text">{HERO_DESCRIPTION}</p>
        </div>
        {(isLogin || isRegister) && (
          <button
            type="button"
            className="kb-auth-hero-link"
            onClick={() => switchMode(isLogin ? 'register' : 'login')}
          >
            {isLogin ? 'Нужна регистрация' : 'Уже есть аккаунт'}
          </button>
        )}
        {(isForgot || isReset) && (
          <button
            type="button"
            className="kb-auth-hero-link"
            onClick={() => switchMode('login')}
          >
            Вернуться ко входу
          </button>
        )}
      </section>

      <section className="kb-auth-panel" aria-label={panelLabel}>
        <div className="kb-auth-panel-brand">
          <BrandMark />
          <span>Купи.баннер</span>
        </div>

        <div className="kb-auth-panel-body">
          <form className="kb-auth-form" onSubmit={handleSubmit}>
            <div className="kb-auth-form-main">
              <h1>{title}</h1>
              {isRegister && (
                <div className="kb-auth-trial-note" role="note" aria-label="Пробный период">
                  <span className="kb-auth-trial-note-icon" aria-hidden="true">✓</span>
                  <span>7 дней бесплатно для новых пользователей</span>
                </div>
              )}
              {isForgot && (
                <p className="kb-auth-hint">
                  Укажите email аккаунта — пришлём ссылку для сброса пароля.
                </p>
              )}

              <div className="kb-auth-form-block">
                <div className="kb-auth-fields">
                  {!isReset && (
                    <label className="kb-auth-field" htmlFor="kb-email">
                      <span>Электронная почта</span>
                      <div className="kb-auth-control">
                        <input
                          id="kb-email"
                          type="email"
                          autoComplete="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="Электронная почта"
                        />
                      </div>
                    </label>
                  )}

                  {(isLogin || isRegister || isReset) && (
                    <div className="kb-auth-field">
                      <span>{isReset ? 'Новый пароль' : 'Пароль'}</span>
                      <div className="kb-auth-control is-password">
                        <input
                          id="kb-password"
                          type={showPassword ? 'text' : 'password'}
                          autoComplete={isLogin ? 'current-password' : 'new-password'}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder={isReset ? 'Новый пароль' : 'Пароль'}
                        />
                        <button
                          type="button"
                          className="kb-auth-control-icon"
                          onClick={() => setShowPassword((prev) => !prev)}
                          aria-label={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                          title={showPassword ? 'Скрыть пароль' : 'Показать пароль'}
                        >
                          <EyeIcon crossed={showPassword} />
                        </button>
                      </div>
                    </div>
                  )}

                  {(isRegister || isReset) && (
                    <label className="kb-auth-field" htmlFor="kb-confirm">
                      <span>Повторите пароль</span>
                      <div className="kb-auth-control is-password">
                        <input
                          id="kb-confirm"
                          type={showPassword ? 'text' : 'password'}
                          autoComplete="new-password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          placeholder="Повторите пароль"
                        />
                      </div>
                    </label>
                  )}
                </div>

                {isLogin && (
                  <label className="kb-auth-check">
                    <input
                      type="checkbox"
                      checked={remember}
                      onChange={(e) => setRemember(e.target.checked)}
                    />
                    <span className="kb-auth-check-box" aria-hidden="true"><i /></span>
                    <span>Запомнить</span>
                  </label>
                )}

                {error && <div className="kb-auth-error">{error}</div>}
                {info && !error && <p className="kb-auth-hint">{info}</p>}
              </div>
            </div>

            <div className="kb-auth-actions">
              <button className="kb-auth-submit" type="submit" disabled={loading}>
                {submitLabel}
              </button>
              {isLogin && (
                <button type="button" className="kb-auth-ghost" onClick={() => switchMode('forgot')}>
                  Забыли пароль?
                </button>
              )}
              {(isForgot || isReset) && (
                <button type="button" className="kb-auth-ghost" onClick={() => switchMode('login')}>
                  Назад ко входу
                </button>
              )}
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}
